import * as React from 'react';

import classNames from 'classnames';

import { ETitleSize } from './enums';

import { IAppTitleProps } from './types';

import * as s from './AppTitle.scss';

export const AppTitle: React.FC<IAppTitleProps> = (props: IAppTitleProps ) => {
	const {
		className,
		text,
		size,
	} = props;
	const modSize = `${size}`;

	return text != null
		? (
			<span className={classNames(className, s.block, s[modSize])}>
				{text}
			</span>
		)
		: null;
};

AppTitle.defaultProps = {
	size: ETitleSize.SMALL,
};
